/* eslint-disable import/no-named-default */
import React, { Suspense } from 'react';
import { createBrowserRouter, createRoutesFromElements, RouterProvider, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'animate.css/animate.min.css';
import 'assets/vendors/style';
import 'styles/omini/omini.less';
import locale from 'antd/lib/locale/vi_VN';
import 'moment/locale/vi';
import { ConfigProvider } from 'antd';
import PosProvider from 'store/providers/PosProvider';
import AuthProvider from 'store/providers/AuthProvider';
import { default as ConfigAppProvider } from 'store/providers/ConfigProvider';
import App from './pages/App/index';
import Loading from './components/Loading';

const queryClient = new QueryClient();
const router = createBrowserRouter(createRoutesFromElements(<Route path="*" element={<App />} />));
function NextApp() {
  return (
    <ConfigProvider locale={locale}>
      <ConfigAppProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <PosProvider>
              <Suspense fallback={<Loading />}>
                <RouterProvider router={router} />
              </Suspense>
            </PosProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ConfigAppProvider>
    </ConfigProvider>
  );
}

export default NextApp;
